module.exports = __webpack_public_path__ + "img/zan-active.d383de1b.svg";